import './Footer.css'

import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import MobileStepper from '@mui/material/MobileStepper';
import StepBackButton from './buttonTemplates/StepBackButton';
import SubstepBackButton from './buttonTemplates/SubstepBackButton';
import StepForwardButton from './buttonTemplates/StepForwardButton';
import SubstepForwardButton from './buttonTemplates/SubstepForwardButton';

const Footer = ({
    steps, activeSubstep, stepForward,
    stepBackward, firstStep, lastStep, firstSubstep,
    lastSubstep, substepIsCompleted, stepIsCompleted, substepChapterBackward,
    substepForward, substepBackward
    }) => {
    const theme = useTheme();
    
    return (
        <footer>
            <StepBackButton stepBackward={stepBackward} firstStep={firstStep}/>
            <MobileStepper
                id='substepMenu'
                variant="dots"
                steps={steps}
                position="static"
                activeStep={activeSubstep}
                sx={{ 
                    gridTemplateColumns: '1fr auto 1fr',
                    maxWidth: 400, 
                    flexGrow: 1 
                }}
                backButton={
                    <SubstepBackButton 
                    substepBackward={substepBackward} 
                    firstSubstep={firstSubstep}
                    firstStep={firstStep} 
                    />
                }
                nextButton={
                    <SubstepForwardButton 
                    substepForward={substepForward} 
                    lastSubstep={lastSubstep} 
                    substepIsCompleted={substepIsCompleted}
                    lastStep={lastStep}
                    />
                }  
            />
            <StepForwardButton stepForward={stepForward} lastStep={lastStep} stepIsCompleted={stepIsCompleted}/>
        </footer>
    );
}

export default Footer;